<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current inline-block"
    :class="[width, height]"
    viewBox="0 0 13 13"
  >
    <path
      id="Icon_material-perm-phone-msg"
      data-name="Icon material-perm-phone-msg"
      d="M16.778,13.528a8.2,8.2,0,0,1-2.578-.412.737.737,0,0,0-.737.173l-1.589,1.589a10.887,10.887,0,0,1-4.759-4.752L8.7,8.53A.709.709,0,0,0,8.884,7.8a8.2,8.2,0,0,1-.412-2.578A.724.724,0,0,0,7.75,4.5H5.222a.724.724,0,0,0-.722.722A12.277,12.277,0,0,0,16.778,17.5a.724.724,0,0,0,.722-.722V14.25A.724.724,0,0,0,16.778,13.528ZM11,4.5v7.222l2.167-2.167H17.5V4.5Z"
      transform="translate(-4.5 -4.5)"
      fill="#f0324c"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-10'
    },
    height: {
      type: String,
      default: 'h-10'
    }
  }
}
</script>
